import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { checkForUpdates, startUpdateChecker, forceReload } from './utils/versionCheck';

// Render app first to avoid blank screen
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Handle page visibility changes (mobile tab switching)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    console.log('Tab became visible, app is ready');
  }
});

// Check for updates after app is rendered (non-blocking)
setTimeout(() => {
  checkForUpdates().then(result => {
    if (result.hasUpdate) {
      console.log('New version detected, prompting user...');
      const shouldUpdate = window.confirm(
        'A new version is available. Would you like to update now?'
      );
      if (shouldUpdate) {
        forceReload();
      } else {
        // User declined, update localStorage to stop asking
        localStorage.setItem('app_version', result.newVersion);
        sessionStorage.setItem('last_checked_version', result.newVersion);
      }
    }
  });
  
  // Start periodic update checker (checks every 30 minutes)
  startUpdateChecker(30);
}, 1000);
